<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>
        Godkendere
      </v-toolbar-title>

      <v-spacer />

      <v-menu
        v-model="addMenu"
        offset-y
        left
        :min-width="500"
        :close-on-content-click="false"
      >
        <template #activator="{ attrs, on }">
          <v-btn small v-bind="attrs" v-on="on">
            Tilføj ansvar
            <v-icon right>
              mdi-plus
            </v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>
              Tilføj ansvar
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-autocomplete
              v-model="newItemId"
              :items="selectableResponsibilities"
              label="Vælg ansvar"
              outlined
              item-value="id"
              item-text="title"
              dense
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-btn
              :loading="creating"
              @click="add"
            >
              Tilføj
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

    </v-toolbar>
    <v-data-table
      :items="items"
      :headers="headers"
      :loading="loading"
    >
      <template #[`item.validFrom`]="{ value }">
        {{ value | formatDateTime }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn small @click="remove(item.id)">
          <v-icon>
            mdi-delete-outline
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
const baseUrl = 'approval-type-approvers';

export default {
  name: 'ApprovalTypeApproversComponent',
  props: {
    approvalType: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      creating: false,
      deleting: false,
      items: [],
      responsibilities: [],
      addMenu: false,
      newItemId: null,
      headers: [
        {
          text: 'Navn',
          value: 'responsibilityName'
        },
        {
          text: 'Gyldig fra',
          value: 'validFrom',
          align: 'right',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'right'
        }
      ]
    }
  },
  computed: {
    selectableResponsibilities() {
      return this.responsibilities.map(responsibility => {
        return {
          ...responsibility,
          disabled: this.items.some(item => item.responsibilityId === responsibility.id)
        }
      });
    }
  },
  mounted() {
    this.getResponsibilities();
  },
  watch: {
    approvalType: {
      handler: function (value) {
        if (value) {
          this.getItems();
        }
      },
      immediate: true
    }
  },
  methods: {
    getItems: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get(baseUrl, {
          params: {
            approvalTypeId: this.approvalType.id,
            isValid: true
          }
        });

        this.items = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    getResponsibilities: async function() {
      try {
        const { data } = await this.$api.get('responsibilities', {
          params: {
            customerId: this.$route.params.customerId
          }
        });

        this.responsibilities = data;
      } catch (error) {
        this.$notifier.showError({});
      }
    },
    add: async function() {
      this.creating = true;

      const model = {
        approvalTypeId: this.approvalType.id,
        responsibilityId: this.newItemId
      };

      try {
        await this.$api.post(baseUrl, model);

        this.addMenu = false;
        this.getItems();
      } catch (error) {
        console.error(error);
      } finally {
        this.creating = false;
      }
    },
    remove: async function(id) {
      if (!confirm('Er du sikker?')) return;

      this.deleting = true;

      try {
        await this.$api.delete('approval-type-approvers/' + id);

        this.getItems();
      } catch (error) {
        console.error(error);
      } finally {
        this.deleting = false;
      }
    }
  }
}
</script>